import React from 'react'
import NavMenuItem from './NavMenuItem'
import NavMenuChildItem from './NavMenuChildItem'
import {menuContainer} from '../styles/nav.module.css'


export default function NavMenu({global, dispatch, location}) {

  const routeParts = location.pathname.split('/')

  const items = [
    {
      label: 'System Activity',
      navKey: '',
      children: [],
    },
    {
      label: 'User Accounts',
      navKey: 'users',
      children: [],
    },
    {
      label: 'Reports',
      navKey: 'reports',
      children: [
        {
          label: 'Learn',
          navKey: 'learn',
        },
        {
          label: 'Work',
          navKey: 'work',
        },
      ],
    },
    {
      label: 'Zoom',
      navKey: 'zoom',
      children: [],
    },
    {
      label: 'Help',
      navKey: 'help',
      children: [],
    },
  ]

  return (
    <div className={menuContainer}>

      {items.map((item) => (
        <NavMenuItem
          key={item.navKey}
          navKey={item.navKey}
          label={item.label}
          route={`/${item.navKey}`}
          active={routeParts[1] === item.navKey && !routeParts[2]}
          expanded={routeParts[1] === item.navKey}
        >
          {item.children.map((childItem) => (
            <NavMenuChildItem
              key={childItem.navKey}
              navKey={childItem.navKey}
              label={childItem.label}
              route={`/${item.navKey}/${childItem.navKey}`}
              active={routeParts[2] === childItem.navKey}
            />
          ))}
        </NavMenuItem>
      ))}

    </div>
  )
}
